export const insertOnCondition = <T>(condition: boolean, ...elements: T[]) => {
  return condition ? elements : [];
};

export function removeByIndex<T>(arr: T[], index: number): T[] {
  const newArray = [...arr];
  newArray.splice(index, 1);
  return newArray;
}
